export function toSentenceCase(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function toTitleCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function toCamelCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, "");
}

export function toSnakeCase(str) {
  if (!str) return "";
  return str.toLowerCase().replace(/\s+/g, "_");
}

export function toKebabCase(str) {
  if (!str) return "";
  return str.toLowerCase().replace(/\s+/g, "-");
}

export function capitalizeEachWord(str) {
  if (!str) return "";
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function removeExtraSpaces(str) {
  if (!str) return "";
  return str.trim().replace(/\s+/g, " ");
}

export function formattedNumber(number, fallback = "00") {
  const num = Number(number);
  if (isNaN(num)) return fallback;
  return num < 10 ? `0${num}` : `${num}`;
}

export function formattedPrice(amount, fallback = "0.00") {
  const num = Number(amount);
  if (isNaN(num)) return fallback;
  const formatted = num.toFixed(2);
  return num < 10 ? `0${formatted}` : formatted;
}

export default {
  capitalizeEachWord,
  formattedNumber,
  formattedPrice,
  removeExtraSpaces,
  toSentenceCase,
  toTitleCase,
  toCamelCase,
  toSnakeCase,
  toKebabCase,
};
